<div class="loader flex justify-center items-center h-screen" *ngIf="loading">
    <div class="text-center">
        <!-- <app-loader type="partial"></app-loader> -->
        <mat-spinner color="accent" class="ms-auto me-auto" [diameter]="30" ></mat-spinner>
        <p class="fw-bold mb-0 mt-4">{{loadingText}}</p>
    </div>  
</div>

<ng-template #termsAndConditions>
    <p>1. Before proceeding, you must accept these Terms and Conditions. If you do not agree, you cannot proceed with Photo ID verification.</p>
    <p>2. Photo ID verification ensures security, prevents fraud, and confirms your identity.</p>
    <p>3. You agree to provide a valid Photo ID (passport, driver’s license, etc.). Your data is used only for verification</p>
    <p>4. Please hold your ID card in your palm while taking the picture. Do not place the ID on a tabletop or any white surface.</p>
    <p>5. You confirm that your information is valid. False submissions may lead to disqualification.</p>
    <p>6. You consent to automated verification through third-party services.</p>
    <p>7. Your data is retained as needed for verification and legal compliance. </p>
    <p>8. We may update these terms. Continued use signifies acceptance.</p>
    <mat-checkbox (change)="onCheckboxChange(   $event)">I have read and accept the terms and conditions</mat-checkbox>
</ng-template>

<div id="camera-container" class="bg-light camera-container" [class.beutification]="isDesktop()"></div>